export default __webpack_public_path__ + "static/media/hul.8f6adf42.svg";